export const ROLES = {
  ADMIN: 'Admin',
  MANAGEMENT: 'Management',
  ADMIN_LEADERBOARD: 'Admin Leaderboard',
  CASHIER: 'Cashier',
  FLOOR_SUPERVISOR: 'Floor Supervisor',
  MANAGER: 'Manager',
};

export const ADMIN_LEADERBOARD_ALLOWED_PATHS = ['/tournament-leaderboard'];

/** Paths reserved for Admin / Management only */
export const MANAGEMENT_ONLY_PATHS = [
  '/',
  '/user-management',
  '/employee-management',
  '/token-reserves',
  '/starting-closing-tables-time',
];

export const MANAGEMENT_ONLY_PREFIXES = ['/dashboard/payroll'];

/** Default landing for Cashier / Floor Supervisor */
export const TRANSACTION_HOME_PATH = '/promos';

export const isAdminLeaderboardRole = (role) => role === ROLES.ADMIN_LEADERBOARD;

export const isAdminRole = (role) => role === ROLES.ADMIN;

export const isManagementRole = (role) =>
  role === ROLES.ADMIN ||
  role === ROLES.MANAGEMENT ||
  role === ROLES.MANAGER ||
  role === 'Manager';

const normalizeRole = (role) => String(role || "").trim().toLowerCase();

export const isFloorRole = (role) => normalizeRole(role) === "floor supervisor";

export const isCashierOrFloorSupervisor = (role) =>
  normalizeRole(role) === "cashier" ||
  isFloorRole(role);

export const isTransactionAccessRole = (role) =>
  isManagementRole(role) || isCashierOrFloorSupervisor(role);

export const isEplPlayersAccessRole = (role) =>
  isManagementRole(role) || isCashierOrFloorSupervisor(role);

/** Send and monitor SMS. Does not include payroll, user management, or other management tools. */
export const isSmsAccessRole = (role) => isEplPlayersAccessRole(role);

export const isManagementOnlyPath = (pathname) => {
  if (MANAGEMENT_ONLY_PATHS.includes(pathname)) return true;
  return MANAGEMENT_ONLY_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
};
